import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const PendingRequests = () => {
    const pendingData = [
        { id: 1, name: 'Rajesh Patel', vehicle: 'MH12XY5678', mobile: '9876543210', purpose: 'Meeting', host: 'Ananya Verma', time: '10:32 AM', gate: 'Security Gate A' },
        { id: 2, name: 'Sneha Rao', vehicle: 'KA05AB1234', mobile: '9988776655', purpose: 'Delivery', host: 'Karan Singh', time: '10:45 AM', gate: 'Security Gate B' },
        { id: 3, name: 'Vikram Desai', vehicle: 'MH14CD9012', mobile: '9123456789', purpose: 'Interview', host: 'HR Department', time: '11:00 AM', gate: 'Security Gate A' },
        { id: 4, name: 'Pooja Sharma', vehicle: 'DL01EF3456', mobile: '9871234560', purpose: 'Vendor', host: 'Facility Admin', time: '11:15 AM', gate: 'Service Gate' },
        { id: 5, name: 'Amitabh Joshi', vehicle: 'GJ03GH7890', mobile: '9001122334', purpose: 'Client Meeting', host: 'Sales Team', time: '11:30 AM', gate: 'Security Gate A' },
    ];

    return (
        <div className="flex flex-col gap-4 mt-2">
            {pendingData.map((req) => (
                <div key={req.id} className="border border-yellow-400 bg-white rounded-xl p-3 shadow-sm flex flex-col md:flex-row justify-between items-start md:items-center gap-3 hover:shadow-md transition-shadow">
                    <div>
                        <div className="flex items-center gap-2 mb-1.5">
                            <span className="bg-[#FEF3C7] text-[#92400E] text-[9px] font-bold px-2 py-0.5 rounded-md">{req.gate} Request</span>
                            <span className="text-[10px] text-gray-500 font-medium">{req.time}</span>
                        </div>
                        <div className="flex items-center gap-2 mb-1.5">
                            <h3 className="text-sm font-bold text-gray-900">{req.name}</h3>
                            <span className="text-gray-300">•</span>
                            <span className="text-blue-600 font-bold px-2 py-0.5 bg-blue-50 border border-blue-100 rounded-md text-[10px]">{req.vehicle}</span>
                        </div>
                        <div className="flex flex-wrap gap-3 text-[10px] text-gray-500">
                            <p>Mobile: <span className="font-semibold text-gray-800">{req.mobile}</span></p>
                            <p>Purpose: <span className="font-semibold text-gray-800">{req.purpose}</span></p>
                            <p>Host: <span className="font-semibold text-gray-800">{req.host}</span></p>
                        </div>
                    </div>
                    <div className="flex gap-2 w-full md:w-auto">
                        <button className="flex-1 md:flex-none px-3 py-1.5 bg-[#059669] hover:bg-[#047857] text-white text-[10px] font-bold rounded-md transition-colors flex items-center justify-center gap-1.5 shadow-sm">
                            <FontAwesomeIcon icon={faCheck} className="text-[10px]" />
                            APPROVE
                        </button>
                        <button className="flex-1 md:flex-none px-3 py-1.5 bg-[#1E293B] hover:bg-slate-800 text-white text-[10px] font-bold rounded-md transition-colors shadow-sm whitespace-nowrap">
                            SEND TO PAY & PARK
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default PendingRequests;
